// src/pages/BlogDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "./firebase/firebaseConfig";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import styled from "styled-components";

const Wrapper = styled.div`
  max-width: 900px;
  margin: auto;
  padding: 40px;
  color: #fff;
  font-family: "Roboto", sans-serif;
`;

const Thumbnail = styled.img`
  width: 100%;
  max-height: 400px;
  border-radius: 12px;
  margin-bottom: 20px;
  object-fit: cover;
`;

const Title = styled.h1`
  color: #00d4ff;
  margin-bottom: 10px;
`;

const Meta = styled.div`
  color: #aaa;
  font-size: 0.9rem;
  margin-bottom: 20px;
`;

const Content = styled.div`
  background: rgba(255, 255, 255, 0.05);
  padding: 20px;
  border-radius: 12px;

  p,
  li {
    color: #ddd;
    line-height: 1.6;
  }
`;

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      const q = query(collection(db, "blogs"), where("slug", "==", slug));
      const snap = await getDocs(q);
      if (!snap.empty) {
        setBlog({ id: snap.docs[0].id, ...snap.docs[0].data() });
      }
    };
    fetchBlog();
  }, [slug]);

  if (!blog) return <Wrapper>Loading...</Wrapper>;

  return (
    <Wrapper>
      <Thumbnail src={blog.thumbnail} alt={blog.title} />
      <Title>{blog.title}</Title>
      <Meta>
        {blog.author} | {blog.category} |{" "}
        {blog.createdAt?.toDate().toLocaleDateString()}
      </Meta>
      <Content dangerouslySetInnerHTML={{ __html: blog.content }} />
    </Wrapper>
  );
};

export default BlogDetail;
